// removed by extract-text-webpack-plugin
module.exports = {"bgfixedOuter":"_2a_tg","bgfixedMiddle":"_2VY6V","bgfixedInner":"_2pMIA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Wrapper/Wrapper.scss
 ** module id = 467
 ** module chunks = 0
 **/